import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"

/**
 * A special tour that shows a notification after a user skips another tour
 * This tour is not persisted and not displayed in tour settings
 */
export const toursCanBeResetTour: TourConfig = {
   id: "tours_can_be_reset_tour",
   humanReadableName: "Tours Can Be Reset",
   // Set this flag to true to indicate this tour should not be shown in settings
   hideFromSettings: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         highlightClass: "shepherd-highlight",
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "settings-hint",
         title: "Tour Skipped",
         text: "Tour skipped. You can reset tours in Project Settings.",
         buttons: [
            {
               action: function () {
                  // Do not persist this tour's completion
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Got it",
            },
         ],
         attachTo: {
            element: ".q-icon.mdi-cog-outline",
            on: "left-end", // Changed from "left" to "left-end" to shift position to the right
         },
         floatingUIOptions: standardOffset,
      },
   ],
}
